import React from 'react';
import { FileText } from 'lucide-react';
import ApplicationRow from './ApplicationRow';

interface Application {
  id: string | number;
  application_number?: string;
  submission_number?: string;
  debtor_id?: string | number;
  credit_type?: string;
  requested_amount?: number;
  tenor_months?: number;
  total_score?: number;
  status: string;
}

interface ApplicationTableProps {
  applications: Application[];
  loading: boolean;
  getDebtorName: (debtorId: string | number | undefined) => string;
  onEdit?: (id: string | number) => void;
  onDelete?: (id: string | number) => void;
  onView?: (id: string | number) => void;
}

function LoadingSkeleton() {
  return Array(5)
    .fill(0)
    .map((_, i) => (
      <tr key={i} className="border-b">
        <td className="px-4 py-3">
          <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-10 w-48 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-6 w-24 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-28 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-6 w-20 bg-gray-200 rounded animate-pulse"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
        </td>
      </tr>
    ));
}

function EmptyState() {
  return (
    <tr>
      <td colSpan={8} className="text-center py-12">
        <FileText className="w-12 h-12 mx-auto mb-3 text-gray-300" />
        <p className="text-gray-500">Tidak ada aplikasi kredit</p>
      </td>
    </tr>
  );
}

export default function ApplicationTable({
  applications,
  loading,
  getDebtorName,
  onEdit,
  onDelete,
  onView,
}: ApplicationTableProps) {
  return (
    <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 border-b">
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">
                No. Aplikasi
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Debitur</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">
                Jenis Kredit
              </th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Plafon</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Tenor</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Skor</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-700">Status</th>
              <th className="w-12 px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkeleton />
            ) : applications.length === 0 ? (
              <EmptyState />
            ) : (
              applications.map(app => (
                <ApplicationRow
                  key={app.id}
                  application={app}
                  debtorName={getDebtorName(app.debtor_id)}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onView={onView}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
